import qs from 'qs'

export function stringifyParams(params: Record<string, unknown>): string {
  return qs.stringify(params, {
    addQueryPrefix: false,
    arrayFormat: 'comma',
    encode: false,
    filter: (_prefix, value) => {
      if (value === undefined || value === null) return
      if (value instanceof Date) return value.toISOString()
      return value
    },
  })
}
